import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ViewService {
    public async tab<T>(name: string, root: T): Promise<any> {
        const tab = await import(`../../view/${name}.json`);
        if (tab.columns) {
            const treeComp = tab.columns.find((column: any) => column.component === 'tree' && !!column.tree);
            if (treeComp) {
                treeComp.tree.root = root;
            }
        }
        return tab;
    }
}
